import RpcClient from './client';
import RpcServer from './server';
export default {
    Client: RpcClient,
    Server: RpcServer
};
